import axios from "axios";
import React, { Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import TrackVisibility from "react-on-screen";
import Layout from "../components/Layout";
import Progress from "../components/Progress";
import Sectiontitle from "../components/Sectiontitle";
import Spinner from "../components/Spinner";

function Portfolios() {
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    let mounted = true;
    axios.get("/api/skills").then((response) => {
      if (mounted) {
        setSkills(response.data);
      }
    });
    return () => (mounted = false);
  }, []);

  return (
    <Layout>
      <Helmet>
        <title>Tomer Ovadia, Software Engineer | Skills</title>
        <meta
          name="description"
          content="Chester React Personal Portfolio Template Skills Page"
        />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-skills-area mi-section mi-padding-top mi-padding-bottom">
          <div className="container">
            <Sectiontitle title="My Skills" />
            <div className="mi-skills">
              <div className="row mt-30-reverse">
                {skills.map((skill) => (
                  <TrackVisibility
                    once
                    className="col-lg-6 mt-30"
                    key={skill.title}
                  >
                    <Progress title={skill.title} percentage={skill.value} />
                  </TrackVisibility>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Suspense>
    </Layout>
  );
}

export default Portfolios;
